import { buttonStyle } from 'components/inputs/Button';
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';
import { RequestStatus, useResponseFn } from 'hooks/useApiCallFn';
import { useAppInstallGetInstallDataHook } from 'api/app-install/app-install';
import LoadingSpinner from 'components/spinners/LoadingSpinner';
import SectionHeader from 'components/SectionHeader';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  gap: 20px;
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  margin: 20px 40px 0px 20px;
`;

const InstallButton = styled.a`
  ${buttonStyle}
  margin: 10px 0;
  text-decoration: none;
  text-align: center;
`;

const MyIcon = styled(FontAwesomeIcon)`
  margin-right: 5px;
`;

const NumberedList = styled.ol`
  list-style-type: decimal;

  li {
    margin: 10px 0;
  }
`;

// Unlisted in the App Store: the app is not searchable, only reachable through this link
const zakraProdAppUrl =
  'https://apps.apple.com/se/app/z%C3%A4kra-go/id1608144339';

const InstallAppPage: React.FC = () => {
  // const theme = useTheme();
  const getInstallData = useAppInstallGetInstallDataHook();
  const appInfoResponse = useResponseFn(() => getInstallData());
  return (
    <Container>
      {appInfoResponse.status === RequestStatus.Fetching ? (
        <LoadingSpinner />
      ) : (
        <>
          <Section>
            <SectionHeader>
              {`Zäkra Go iOS ${appInfoResponse.response?.iosVersionInfo?.version}`}
            </SectionHeader>
            <InstallButton href={zakraProdAppUrl}>
              <MyIcon icon={faApple} />
              Ladda ner Zäkra Go-appen
            </InstallButton>
            <NumberedList>
              <li>Ladda ner appen ovan</li>
              <li>Tryck på app-ikonen</li>
              <li>Nu kan du börja använda appen!</li>
            </NumberedList>
          </Section>

          <Section>
            <SectionHeader>
              {`Zäkra Go Android ${appInfoResponse.response?.androidVersionInfo?.version}`}
            </SectionHeader>
            <InstallButton href={appInfoResponse.response?.androidInstallPath}>
              <MyIcon icon={faAndroid} /> Ladda ner Android-appen
            </InstallButton>
            <NumberedList>
              <li>Tryck på knappen ovan</li>
              <li>
                Spara och öppna app-filen (kan variera beroende på telefon och
                webbläsare)
              </li>
              <li>
                Du kan eventuellt behöva tillåta att appen ska få installeras av
                webbläsaren
              </li>
              <li>
                Tryck på <b>installera</b>
              </li>
            </NumberedList>
          </Section>
        </>
      )}
    </Container>
  );
};

export default InstallAppPage;
